import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const DeleteIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.6", ...props.sx}} viewBox="0 0 18 18">
        <path
            d="M1.5 4.2H3.16667M3.16667 4.2H16.5M3.16667 4.2V15.4C3.16667 15.8243 3.34226 16.2313 3.65482 16.5314C3.96738 16.8314 4.39131 17 4.83333 17H13.1667C13.6087 17 14.0326 16.8314 14.3452 16.5314C14.6577 16.2313 14.8333 15.8243 14.8333 15.4V4.2H3.16667ZM5.66667 4.2V2.6C5.66667 2.17565 5.84226 1.76869 6.15482 1.46863C6.46738 1.16857 6.89131 1 7.33333 1H10.6667C11.1087 1 11.5326 1.16857 11.8452 1.46863C12.1577 1.76869 12.3333 2.17565 12.3333 2.6V4.2M7.33333 8.2V13M10.6667 8.2V13"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
